// Latency buckets for the Layer-wise latency breakdown table.
// `field` is the count field in the API rows, `tone` drives the cell colour.
// City / depot rows: no. of VINs whose average latency falls in the bucket.
// VIN rows: no. of packets in the bucket.
export const LATENCY_BUCKETS = [
    { label: "0–5s", field: "0-5", tone: "yellow" },
    { label: "5-10s", field: "5-10", tone: "green" },
    { label: "10-20s", field: "10-20", tone: "green" },
    { label: "20-30s", field: "20-30", tone: "amber" },
    { label: "30-45s", field: "30-45", tone: "amber" },
    { label: "45-60s", field: "45-60", tone: "red" },
    { label: ">60s", field: ">60", tone: "red" }
];

// which bucket an average latency (sec) falls into
export const getLatencyBucket = (seconds) => {
    if (seconds <= 5) return LATENCY_BUCKETS[0];
    if (seconds <= 10) return LATENCY_BUCKETS[1];
    if (seconds <= 20) return LATENCY_BUCKETS[2];
    if (seconds <= 30) return LATENCY_BUCKETS[3];
    if (seconds <= 45) return LATENCY_BUCKETS[4];
    if (seconds <= 60) return LATENCY_BUCKETS[5];
    return LATENCY_BUCKETS[6];
};

// percentage tone (Actual % / Overall %): >= 80 green, 70–79 amber, below 70 red
export const getPercentTone = (pct) => {
    if (pct === null || pct === undefined || pct === "") return "grey";
    if (Number(pct) >= 80) return "green";
    if (Number(pct) >= 70) return "amber";
    return "red";
};

export const formatPercent = (pct) =>
    pct === null || pct === undefined || pct === "" ? "-" : `${Number(pct).toFixed(1)}%`;
